import { INLINES } from '@contentful/rich-text-types';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { renderRichText } from 'gatsby-source-contentful/rich-text';
import { PropTypes } from 'prop-types';
import React from 'react';

import { getPerformanceCookie } from '../../../utils';
import WistiaVideoPlayer from '../WistiaVideoPlayer';

const ArticleHeroImage = ({
  article = true,
  image,
  text,
  title,
  wistiaVideoId,
}) => {
  let performanceCookieOn = false;
  if (typeof window !== 'undefined') {
    performanceCookieOn = getPerformanceCookie(window);
  }

  if (wistiaVideoId && performanceCookieOn) {
    return (
      <div className={`article__hero ${!article ? 'article__hero--pad' : ''} `}>
        <WistiaVideoPlayer title={title} wistiaVideoId={wistiaVideoId} />
      </div>
    );
  }
  return (
    <div className={`article__hero ${!article ? 'article__hero--pad' : ''} `}>
      <GatsbyImage alt={title} image={getImage(image)} />
      {text && typeof text === 'object' && (
        <div className="article__hero--text">
          {renderRichText(text, {
            renderNode: {
              [INLINES.HYPERLINK]: (node) => (
                <a href={node.data.uri}>{node.content[0].value}</a>
              ),
            },
          })}
        </div>
      )}
      {text && typeof text === 'string' && (
        <div className="article__hero--text">
          <h2>{text}</h2>
        </div>
      )}
    </div>
  );
};

ArticleHeroImage.propTypes = {
  article: PropTypes.bool,
  image: PropTypes.object,
  text: PropTypes.object,
  title: PropTypes.string,
  wistiaVideoId: PropTypes.string,
};

export default ArticleHeroImage;
